import React, {useState} from "react";
import CNDTTable from "./CNDTTable/CNDTTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../../utils/utils";
import { useTranslation } from "react-i18next";

function CNDTCard(props) {
    const { t } = useTranslation()

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);


    const {cndt} = props
    let initialExpand = cndt.flag === "positive"? false : true
    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }
    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    {t("cndt")}
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(cndt.flag)}
                </div>
                {cndt.data.length === 0 ? null :
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>             
                }                    
            </div>
            {cndt.data.length === 0 ? null :
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div 
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <CNDTTable cndt_data={cndt.data}/>
                </div>
            </Collapse> 
            }     
        </div>
        );
}


export default CNDTCard